var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.624,
    height: 28.095,
    viewBox: "0 0 30.624 28.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_9927",
    x: 0,
    y: 0,
    width: 30.624,
    height: 28.095,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_checkbox",
    transform: "translate(5.128 1.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2012",
    "data-name": "Rectangle 2012",
    transform: "translate(0.403)",
    fill: "#00b220",
    stroke: "#008919",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.13, -1.05)",
    filter: "url(#Path_9927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9927-2",
    "data-name": "Path 9927",
    d: "M24.33,31.171c-.1-.092-.147-.138-.2-.187L22.153,29a.463.463,0,0,0-.773,0q-.705.7-1.4,1.407a.461.461,0,0,0,0,.773l3.911,3.925c.313.314.5.315.814,0l7.466-7.462c.3-.3.3-.492-.006-.8q-.67-.675-1.345-1.345c-.344-.342-.53-.341-.877.005l-5.452,5.456A1.9,1.9,0,0,0,24.33,31.171Z",
    transform: "translate(-10.77 -19.25)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckbox);
export default __webpack_public_path__ + "static/media/ic_checkbox.6b8f95696257410630b217ca3e3d6389.svg";
export { ForwardRef as ReactComponent };